import axios from '../utils/axios'

const getNetworkingSummary = (params) => {
    return new Promise((resolve, reject) => {
        const url = `/api/networking/tool`
        axios.post(url, params)
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}

const getResumeSummary = (params, url = '/api/resume/tool') => {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
    })
}

export {
    getNetworkingSummary, getResumeSummary
}
